import {EApiKeyType, ECallbackType, EIntegrationSettingsTab} from './definitions';

export default {
  tabs: {
    [EIntegrationSettingsTab.MASTER]: 'Основной профиль',
    [EIntegrationSettingsTab.API_KEY]: 'API-ключ',
    [EIntegrationSettingsTab.CALLBACK]: 'Вебхук',
  },
  masterSettings: {
    callbackSettings: 'Настройка вебхука',
    addCallback: 'Добавить вебхук',
    changeCallback: 'Изменить URL',
    modalNote: 'Для корректной работы настроек требуется проверка URL',
    modalText: 'Вебхук, только HTTPS, порт 443',
    errorMessage: 'Запрашиваемый ресурс не существует',
    jivoConnectedMessage: 'Изменить вебхук нельзя, так как у вас подключен готовый модуль Jivo',
    checkMessage:
      'Для проверки доступности мы пошлем HEAD запрос, на который ожидаем увидеть ответ со статусом 200. В противном случае мы не сможем зарегистрировать ваш вебхук.',
    callbackUrlType: {
      [ECallbackType.IN_MESSAGE]: {
        title: 'Вебхук о получении входящих сообщений',
        description: 'На указанный URL вы можете получать входящие сообщения от клиентов.',
        add: {
          title: 'Добавить вебхук о получении входящих сообщений',
        },
        change: {
          title: 'Изменить вебхук о получении входящих сообщений?',
        },
        delete: {
          title: 'Удалить вебхук о получении входящих сообщений?',
          notification: 'Вебхук о получении входящих сообщений успешно удален',
        },
      },
      [ECallbackType.STATUS]: {
        title: 'Вебхук об изменении статуса сообщения',
        description: 'На указанный URL вы можете получать статусы отправленных рассылок.',
        add: {
          title: 'Добавить вебхук об изменении статуса сообщения',
        },
        change: {
          title: 'Изменить вебхук об изменении статуса сообщения?',
        },
        delete: {
          title: 'Удалить вебхук об изменении статуса сообщения?',
          notification: 'Вебхук об изменении статуса сообщения успешно удален',
        },
      },
      [ECallbackType.MESSAGE_MATCHER]: {
        title: 'Вебхук об изменении статуса шаблона',
        description:
          'На указанный URL вы можете получать информацию об обновлении статуса шаблонов, отправленных на регистрацию.',
        add: {
          title: 'Добавить вебхук об изменении статуса шаблона',
        },
        change: {
          title: 'Изменить вебхук об изменении статуса шаблона?',
        },
        delete: {
          title: 'Удалить вебхук об изменении статуса шаблона?',
          notification: 'Вебхук об изменении статуса шаблона успешно удален',
        },
      },
      [ECallbackType.MESSAGE_MATCHER_CATEGORY_CHANGED]: {
        title: 'Вебхук об изменении категории шаблона WhatsApp',
        description:
          'На указанный URL вы можете получать информацию об обновлении категории шаблона WhatsApp со стороны Meta.',
        add: {
          title: 'Добавить вебхук об изменении категории шаблона WhatsApp',
        },
        change: {
          title: 'Изменить вебхук об изменении категории шаблона WhatsApp?',
        },
        delete: {
          title: 'Удалить вебхук об изменении категории шаблона WhatsApp?',
          notification: 'Вебхук об изменении категории шаблона WhatsApp успешно удален',
        },
      },
      [ECallbackType.SHORT_LINK_VISITED]: {
        title: 'Вебхук о переходе получателя по кнопке-ссылке в WhatsApp',
        description:
          'На указанный URL вы можете получать информацию о переходах получателей по кнопкам-ссылкам в каналах WhatsApp, если используете шаблоны с настройкой отслеживания переходов.',
        add: {
          title: 'Добавить вебхук о переходе получателя по кнопке-ссылке в WhatsApp',
        },
        change: {
          title: 'Изменить вебхук о переходе получателя по кнопке-ссылке в WhatsApp?',
        },
        delete: {
          title: 'Удалить вебхук о переходе получателя по кнопке-ссылке в WhatsApp?',
          notification: 'Вебхук о переходе получателя по кнопке-ссылке в WhatsApp успешно удален',
        },
      },
      [ECallbackType.SENDER_STATUS]: {
        title: 'Вебхук об изменении статуса канала',
        description:
          'На указанный URL вы можете получать информацию о статусе отправителя (создан/заблокирован/разблокирован).',
        add: {
          title: 'Добавить вебхук об изменении статуса канала',
        },
        change: {
          title: 'Изменить вебхук об изменении статуса канала?',
        },
        delete: {
          title: 'Удалить вебхук об изменении статуса канала?',
          notification: 'Вебхук об изменении статуса канала успешно удален',
        },
      },
    },
    yourAPIKey: 'Ваш API-ключ',
    APIKeyDescription:
      'Вы можете проинтегрировать наш сервис с любым приложением, получив доступ к рассылкам сообщений через API.<br/>Со всеми методами API вы можете ознакомиться<br/> в <0>инструкции разработчика</0>.',
    generateAPIKey: 'Сгенерировать API-ключ',
    generateNewAPIKey: 'Новый API-ключ',
    callbackAuth: 'Аутентификация вебхук-запросов',
    callbackAuthHint:
      'Вы можете включить аутентификацию вебхук-запросов edna Pulse к вашему серверу. Установите флажок, чтобы сгенерировать API-ключ. edna Pulse будет использовать его при отправке вебхука на ваш API-endpoint.',
    callbackAuthSwitch: 'Включить аутентификацию запросов edna Pulse',
    generateNewCallbackKey: 'Новый ключ для вебхук-запросов',
    authErrorText: 'Не удалось выполнить запрос, попробуйте позже.',
    connected: 'Подключен',
  },
  changeApiKeyModal: {
    title: 'Изменить API-ключ?',
    message:
      'При смене API-ключа прекратится трафик, который поступал по старому ключу. Для корректной работы скопируйте новый ключ и вставьте его себе в систему.',
  },
  authCallbackKeyModal: {
    title: 'Скопируйте ваш API-ключ для аутентификации',
    warning:
      'Ради безопасности ваших данных API-ключ отображается полностью и может быть скопирован только один раз, потом вы не сможете увидеть его целиком или скопировать. Скопируйте его сейчас и передайте разработчику или сохраните в надежном месте.',
  },
  apiKeySettings: {
    title: 'Дополнительные API-ключи',
    generate: 'Сгенерировать',
    keyName: 'Название API-ключа',
    keyValue: 'Ключ',
    validTo: 'Действителен до',
    status: 'Состояние',
    permissions: 'Доступные методы',
    subjects: 'Подключенные отправители',
    subjectStatus: 'Статус отправителя',
  },
  apiKeyType: {
    [EApiKeyType.MESSAGE_HISTORY]: 'История сообщений',
    [EApiKeyType.CHANNEL_PROFILE]: 'Каналы',
    [EApiKeyType.CASCADE]: 'Каскады',
    [EApiKeyType.CALLBACK]: 'Вебхуки',
    [EApiKeyType.OUT_MESSAGES]: 'Отправка сообщений',
    [EApiKeyType.MESSAGE_MATCHERS]: 'Шаблоны',
    [EApiKeyType.IN_MESSAGE]: 'Подтверждение прочтения',
    [EApiKeyType.CHATBOTS]: 'Сценарии',
  },
  apiKeyForm: {
    keyData: 'API-ключ',
    keyName: 'Название API-ключа',
    keyNameHint: 'Внутреннее название, помогает ориентироваться в списке дополнительных API-ключей',
    params: 'Параметры ключа',
    validTo: 'Срок действия API-ключа',
    unlimitedValidity: 'Не ограничен',
    limitedValidity: 'Действителен до даты',
    subjects: 'Отправители',
    select: 'Выбрать',
    permissions: 'Доступ к набору методов',
    selectPermissions: 'Отметьте необходимые методы ',
  },
  apiKeyDeleteModal: {
    title: 'Удалить API-ключ?',
    description: 'Будет удален уникальный идентификатор для доступа к edna Pulse',
  },
  callbackSettings: {
    title: 'Дополнительные вебхуки',
    addCallback: 'Добавить вебхук',
    name: 'Название вебхука',
    url: 'URL',
    status: 'Состояние',
    hasAuthCallback: 'Аутентификация запросов edna включена',
    subjects: 'Подключенные отправители',
    subjectStatus: 'Статус отправителя',
    types: 'Подключенные вебхуки',
  },
  callbackType: {
    [ECallbackType.STATUS]: 'Вебхук об изменении статуса сообщения',
    [ECallbackType.IN_MESSAGE]: 'Вебхук о получении входящих сообщений',
    [ECallbackType.MESSAGE_MATCHER]: 'Вебхук об изменении статуса шаблона',
    [ECallbackType.MESSAGE_MATCHER_CATEGORY_CHANGED]:
      'Вебхук об изменении категории шаблона WhatsApp',
    [ECallbackType.SHORT_LINK_VISITED]: 'Вебхук о переходе получателя по кнопке-ссылке в WhatsApp',
    [ECallbackType.SENDER_STATUS]: 'Вебхук об изменении статуса канала',
  },
  callbackForm: {
    data: 'Данные вебхука',
    dataEdit: 'Изменить данные вебхука',
    name: 'Название вебхука',
    nameHint: 'Внутреннее название, помогает ориентироваться в списке дополнительных вебхуков',
    url: 'Адрес URL',
    urlHint:
      'Адрес вашего сервера, на который будут приходить вебхук-запросы с информацией о событиях',
    additionalUrl: 'Адрес дополнительного URL (опционально)',
    authCallbackEdit: 'Изменить аутентификацию запросов',
    authCallback: 'Аутентификация запросов',
    regenerateKey: 'Перегенерировать ключ',
    authCallbackHint:
      'Аутентификация запросов необходима для проверки того, что данные пришли из надежного источника\n' +
      'Установите флажок, чтобы сгенерировать API-ключ. Edna Pulse будет использовать его при отправке вебхук-запроса на ваш API-endpoint',
    authCallbackToggle: 'Аутентификация запросов от edna Pulse',
    authCallbackActive:
      'Подключен API-ключ для аутентификации запросов. Edna Pulse будет использовать его при отправке вебхук-запроса на ваш API-endpoint',
    generateAuthCallbackKey: 'Новый ключ для вебхук-запросов',
    params: 'Параметры вебхука',
    paramsEdit: 'Изменить параметры вебхука',
    subjects: 'Отправители',
    types: 'Выберите типы вебхуков',
    selectTypes: 'Отметьте необходимые методы и заполните поле URL',
    successNotification: 'Вебхук успешно изменен',
  },
  callbackDeleteModal: {
    title: 'Удалить вебхук?',
    description: 'Вебхук будет удален без возможности восстановления',
  },
  subjectLockedStatus: {
    blocked: 'Заблокирован',
    active: 'Активный',
  },
};
